export default __webpack_public_path__ + "static/media/NS.751e111f.png";